<div class="lex-progress-bar__track">
  <div
    [ngStyle]="{ 'width.%': value, 'background-color': color }"
    class="lex-progress-bar__indicator"
  ></div>
</div>
